// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"c8951a81","98":"2ba3725a","131":"e2a80105","142":"8e23b58f","374":"d9955801","438":"9bb4248c","439":"2644405b","446":"83427b34","453":"9330cc4b","456":"58b5fbcf","507":"b184bd69","616":"a6c010e6","686":"cc5bf728","780":"47fe5b33","923":"4176cc6b","976":"e6b34e89"}[chunkId] + ".chunk.js";
};